<template>

	<div class="container-fluid mt-5">
		<div class="row mb-3">
			<h2>FLUX Points</h2>
			<p>Earn points by trading through FluxBot</p>
		</div>

		<div class="row mb-3">
			<div class="col-12 mb-3 mb-md-0">
<!--			<div class="col-12 col-md-6 mb-3 mb-md-0">-->
				<div class="card">
					<div class="card-header"><h4 class="mb-0">Total Points</h4></div>
					<div class="card-body text-center"><h1>{{ (stats?.total_points || 0).toLocaleString() }}</h1></div>
				</div>
			</div>
<!--			<div class="col-12 col-md-4">-->
<!--				<div class="card">-->
<!--					<div class="card-header"><h4 class="mb-0">Active Users</h4></div>-->
<!--					<div class="card-body text-center"><h1>{{ (stats?.user_count || 0).toLocaleString() }}</h1></div>-->
<!--				</div>-->
<!--			</div>-->
<!--			<div class="col-12 col-md-6">-->
<!--				<div class="card">-->
<!--					<div-->
<!--							class="card-header"><h4 class="mb-0 d-inline-block">Your Rank</h4><span class="xsmall d-inline-block float-end">{{ (userRank?.points || 0).toLocaleString() }}-->
<!--						Points</span></div>-->
<!--					<div v-if="userRank?.rank" class="card-body text-center"><h1>#{{ (userRank?.rank || 0).toLocaleString() }}</h1></div>-->
<!--					<div v-else class="card-body text-center"><h1>-</h1></div>-->
<!--				</div>-->
<!--			</div>-->
		</div>

		<div class="row animate__animated animate__fadeIn text-center">
			<div class="col-12 col-sm-6 offset-0 offset-md-2 col-md-4 mb-2 mb-md-0">
				<a href="https://t.me/fluxbeam_bot" target="_blank">
					<FancyButton>🤖 Open FluxBot</FancyButton>
				</a>
			</div>
			<div class="col-12 col-sm-6 col-md-4">
				<a href="https://t.me/fluxbeam_bot" target="_blank">
					<FancyButton>🎁 Referral Link</FancyButton>
				</a>
			</div>
		</div>

		<div class="card animate__animated animate__fadeIn mt-3">
			<div class="card-body mt-3">
				<div v-if="rankings.length === 0">
					<p class="text-center my-5">No Rankings found, check back later</p>
				</div>
				<table class="table table-borderless" v-else>
					<thead>
					<tr>
						<th>#</th>
						<th>User</th>
						<th class="text-end">Total Points</th>
					</tr>
					</thead>
					<tbody>
					<tr v-for="(rank,idx) in rankings" :key="idx" class="animate__animated animate__fadeIn">
						<td>{{ idx }}</td>
						<td>{{ shortAddr(rank.username) }} <span v-if="idx===0" title="Current Leader">🏆</span></td>
						<td class="text-end">{{ parseInt(rank.points).toLocaleString() }}</td>
					</tr>
					</tbody>
				</table>
			</div>
			<div class="card-footer text-center">
				<button class="btn btn-primary px-5" @click="loadMore">Load More</button>
			</div>
		</div>
	</div>
</template>

<script>
import FluxBotClient from "@/api/fluxbot/client";
import FancyButton from "@/components/FancyButton.vue";

export default {
	name: "LeaderboardView",
	components: {FancyButton},
	data() {
		return {
			client: new FluxBotClient(),
			page: 0,
			rankings: [],
			stats: null,
			userRank: null,
		}
	},
	methods: {
		shortAddr:function (addr) {
			return `${addr.substr(0, 4)}...${addr.substr(-4)}`
		},
		loadMore: function () {
			this.page++
			this.client.getPointsLeaderboard(this.page).then(r => {
				this.rankings.push(...r)
			})
		},
		getRankings: function () {
			this.client.getPointsLeaderboard(this.page).then(r => {
				this.rankings = r
			})
		},
		isStaff: function (name) {
			if (name === "cloakd" || name === "cloakd_old")
				return "👑"

			return ""
		},
		getStats: function () {
			this.client.getStats().then(r => this.stats = r)
		},
		getUserRank: function () {
			this.client.getRank(this.$store.state.wallet.address).then(r => {
				this.userRank = r
			})
		}
	},
	mounted() {
		this.getStats()
		this.getRankings()
		this.getUserRank()
	}
}
</script>

<style scoped>
.xsmall {
	font-size: 0.7rem;
}
</style>